export type Language = {
  text: string;
  label: string;
  isOpen: boolean;
};

const languages: Language[] = [
  {
    text: "中文",
    label: "zh",
    isOpen: true,
  },
  {
    text: "English",
    label: "en",
    isOpen: true,
  },
  {
    text: "日本語",
    label: "jp",
    isOpen: false,
  },
  {
    text: "Français",
    label: "fr",
    isOpen: false,
  },
  {
    text: "Deutsch",
    label: "brd",
    isOpen: false,
  },
];

export default languages;
